export default __webpack_public_path__ + "static/pageload-1c99726ccb4d428d88a47747809e1891.gif";